import React, { FC, memo } from 'react'

import { useFindNearestByImgWidth } from '@/hooks/useFindNearestByImgWidth'
import { ImageSourceType } from '@/types/servicesTypes/configTypes'

import { ImageBox, StyledImage } from './styles'

const ChannelImageRaw: FC<{ sources: Array<ImageSourceType> | undefined }> = ({
  sources,
}) => {
  const iconSrc = useFindNearestByImgWidth(sources, 150, {
    prioritizeSvg: true,
  })?.url
  return (
    <ImageBox>
      <StyledImage src={iconSrc} />
    </ImageBox>
  )
}

export const ChannelImage = memo(ChannelImageRaw)
